import * as styles from './styles/styles.module.scss';
import useEmployeeQuote from './hooks/useEmployeeQuote';
import { QUOTES } from './quotes';

// Careers page does not need translations
const EmployeeQuotes = (): JSX.Element => {
  const { name, quote, role } = useEmployeeQuote(QUOTES);

  return (
    <div className={styles.quoteBlock}>
      <div className={styles.quoteContainer}>
        <h2 className={styles.title}>Working at AllTrails</h2>
        <div className={styles.quote}>{quote}</div>
        <div className={styles.name}>{name}</div>
        <div className={styles.role}>{role}</div>
      </div>
    </div>
  );
};

export default EmployeeQuotes;
